import { toUnicode } from "punycode/";

export function displayHostname(website: string) {
  try {
    return toUnicode(new URL(website).hostname);
  } catch {
    return website;
  }
}

export function displayWebsite(website: string) {
  try {
    const url = new URL(website);
    const credentials = url.username
      ? `${url.username}${url.password ? `:${url.password}` : ""}@`
      : "";
    return `${url.protocol}//${credentials}${toUnicode(url.hostname)}${url.port ? `:${url.port}` : ""}${url.pathname}${url.search}${url.hash}`;
  } catch {
    return website;
  }
}
